"use strict";

angular.module("exploitation")

	.controller("VariationsCtrl", [
		"$scope", "lines", "newLines", "deleteLines", "vehicleJourneys", "newVehicleJourneys", "deleteVehicleJourneys", "stops", "newStops", "deleteStops",
		function ($scope, lines, newLines, deleteLines, vehicleJourneys, newVehicleJourneys, deleteVehicleJourneys, stops, newStops, deleteStops) {

		$scope.data = {
			lines: lines.data,
			newLines: newLines.data,
			deleteLines: deleteLines.data,


			vehicleJourneys: vehicleJourneys.data,
			newVehicleJourneys: newVehicleJourneys.data,
			deleteVehicleJourneys: deleteVehicleJourneys.data,

			stops: stops.data,
			newStops: newStops.data,
			deleteStops: deleteStops.data
		};
	}]);